var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-xmark-regular",
    d: "M11,2.063A8.938,8.938,0,1,1,2.062,11,8.938,8.938,0,0,1,11,2.063ZM11,22A11,11,0,1,0,0,11,11,11,0,0,0,11,22ZM7.52,7.52a1.027,1.027,0,0,0,0,1.457L9.539,11l-2.02,2.02a1.03,1.03,0,0,0,1.457,1.457L11,12.452l2.02,2.02a1.03,1.03,0,0,0,1.457-1.457L12.452,11l2.02-2.02A1.03,1.03,0,0,0,13.015,7.52L11,9.539,8.976,7.52A1.027,1.027,0,0,0,7.52,7.52Z",
    fill: "#686868"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCircleIcon);
export default __webpack_public_path__ + "static/media/remove-circle-icon.c73b9a61fe260dbcf7cb3d34e2e3c04e.svg";
export { ForwardRef as ReactComponent };